var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18164 2.22559V3.72559H4.43164C3.19531 3.72559 2.18164 4.73926 2.18164 5.97559V19.4756C2.18164 20.7119 3.19531 21.7256 4.43164 21.7256H19.4316C20.668 21.7256 21.6816 20.7119 21.6816 19.4756V5.97559C21.6816 4.73926 20.668 3.72559 19.4316 3.72559H18.6816V2.22559H17.1816V3.72559H6.68164V2.22559H5.18164ZM4.43164 5.22559H5.18164V6.72559H6.68164V5.22559H17.1816V6.72559H18.6816V5.22559H19.4316C19.8535 5.22559 20.1816 5.55371 20.1816 5.97559V8.22559H3.68164V5.97559C3.68164 5.55371 4.00977 5.22559 4.43164 5.22559ZM3.68164 9.72559H20.1816V19.4756C20.1816 19.8975 19.8535 20.2256 19.4316 20.2256H4.43164C4.00977 20.2256 3.68164 19.8975 3.68164 19.4756V9.72559ZM12.6816 12.7256V17.2256H17.1816V12.7256H12.6816ZM14.1816 14.2256H15.6816V15.7256H14.1816V14.2256Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0391bc4929e29280ab3b308a9cd3150a.svg";
export { ForwardRef as ReactComponent };